<template lang="html">
  <div class="rate">
    <v-input
      tooltip="hover"
      type="range"
      :interval="1"
      v-model="vmodelvalue"
      :value="value"
      :min="1"
      :max="5"
      :refresh="refresh"
    >
      <slot></slot>: <b>{{ value }}</b>
    </v-input>
  </div>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: ''
    },
    refresh: {
      type: Boolean,
      default: false
    },
    value: {
      type: Number,
      default: 4
    }
  },
  computed: {
    vmodelvalue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/parts/components/rate.vue